import React from 'react';
import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

import {
  ReportDisplayStatus,
  STATUS_CONFIG,
} from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportStatusIcon/ReportStatusIcon.utils';

export interface ReportStatusIconProps {
  displayStatus: ReportDisplayStatus;
}

export const ReportStatusIcon: React.FC<ReportStatusIconProps> = ({
  displayStatus,
}) => {
  const { column, color, label } = STATUS_CONFIG[displayStatus];
  const { Icon, size: iconSize = '24px' } = column;

  return (
    <Tooltip
      roundedContainer
      content={
        <Copy variant="body" color="invertedPrimaryText">
          {label}
        </Copy>
      }
    >
      <Flex alignItems="center" aria-label={label}>
        <Copy variant="body" color={color}>
          <Icon size={iconSize} />
        </Copy>
      </Flex>
    </Tooltip>
  );
};
